import plauth from './locales/pl/auth.json';
import enauth from './locales/en/auth.json';
import plcommon from './locales/pl/common.json';
import encommon from './locales/en/common.json';
import plpublic from './locales/pl/public.json';
import enpublic from './locales/en/public.json';
import plcalendar from './locales/pl/calendar.json';
import encalendar from './locales/en/calendar.json';
import plmanage from './locales/pl/manage.json';
import enmanage from './locales/en/manage.json';
import plclient from './locales/pl/client.json';
import enclient from './locales/en/client.json';
import plbilling from './locales/pl/billing.json';
import enbilling from './locales/en/billing.json';

export default {
  pl: { auth: plauth, common: plcommon, public: plpublic, calendar: plcalendar, manage: plmanage, client: plclient, billing: plbilling },
  en: { auth: enauth, common: encommon, public: enpublic, calendar: encalendar, manage: enmanage, client: enclient, billing: enbilling },
};
